module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/mauloa-1b89078e6d8865d55553d496a89b4575.png";